import { CSSObject } from '@emotion/react'
import { Box, Color, withCitrusTheme } from '@gousto-internal/citrus-react'

// Named `CWCTrendingPill`, not `Pill` — Citrus already exports a real `Pill` (a `Badge` variant:
// `BadgeVariant.Default|Actionable|Confirmation|Error`), which has no way to express this dark,
// translucent-white styling, so it isn't a drop-in replacement. Kept custom to avoid shadowing it.
export const CWCTrendingPill = withCitrusTheme(Box, (theme) => [
  {
    backgroundColor: 'rgba(255, 255, 255, 0.06)',
    border: '1px solid rgba(255, 255, 255, 0.16)',
    borderRadius: '999px',
    paddingLeft: '13px',
    paddingRight: '13px',
    color: theme.color(Color.White),
    fontFamily: theme.tokens.FontFamilies.bold,
    fontWeight: 700,
  } as CSSObject,
  // 8px (not 9px) accounts for the pill's 1px border to hit Figma's 34px height.
  theme.responsiveSpacing(2, ['paddingTop', 'paddingBottom']) as CSSObject,
  // Citrus FontSize scale: 0 = 12px/16px (Figma's mobile size), 1 = 14px/16px (tablet/desktop).
  theme.responsiveFont([0, 1, 1, 1]) as CSSObject,
])
